// import queryString from 'query-string';
import { combineReducers } from 'redux';
import globalReducer, { isGlobalAction, propagateAction } from 'userportal/ducks/global';
import app from 'userportal/ducks/app';
import auth from 'userportal/ducks/auth';
import applications from 'userportal/ducks/applications';
import offers from 'userportal/ducks/offers';
import roles from 'userportal/ducks/roles';
import languages from 'userportal/ducks/languages';
import fields from 'userportal/ducks/fields';
import profile from 'userportal/ducks/profile';
import jobSearch from 'userportal/ducks/jobSearch';
import settings from 'userportal/ducks/settings';
import currencies from 'userportal/ducks/currencies';
import visited from 'userportal/ducks/visited';
import notifications from 'userportal/ducks/notifications';
import favoriteJobs from 'userportal/ducks/favoriteJobs';

export default () => {
  const reducers = combineReducers({
    app,
    auth,
    applications,
    offers,
    roles,
    languages,
    fields,
    profile,
    jobSearch,
    settings,
    currencies,
    visited,
    notifications,
    favoriteJobs,
  });

  return (state, action) => {
    let nextState = state;
    if (isGlobalAction(action)) {
      nextState = globalReducer(state, action);
      if (!propagateAction(action)) {
        return nextState;
      }
    }

    return reducers(nextState, action);
  };
};
